// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25":"51b211dd","286":"f0e2f5f6","378":"24ef3998"}[chunkId] + ".css";
};